<template>
  <div id="inspire" class="dashboard-container">
    <!-- Pantalla de Carga -->
    <div v-if="propLoading" class="loading-overlay">
      <div class="v-spinner">
        <div class="v-sync v-sync1" :style="spinnerStyle"></div>
        <div class="v-sync v-sync2" :style="spinnerStyle"></div>
        <div class="v-sync v-sync3" :style="spinnerStyle"></div>
      </div>
    </div>

    <div v-else class="dashboard-layout">
      <!-- Barra Superior -->
      <v-app-bar app flat class="dashboard-toolbar" color="white">
        <v-toolbar-title class="brand-title">
          <span class="text-primary font-weight-bold">PREMIOS</span>
          <span class="text-secondary ml-1">USUARIO</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text color="#294697" @click="logout" class="logout-btn">
          <span class="mr-2">SALIR</span>
          <v-icon small>mdi-logout-variant</v-icon>
        </v-btn>
      </v-app-bar>

      <!-- Barra Lateral -->
      <v-navigation-drawer
        v-model="drawer"
        app
        permanent
        class="dashboard-drawer"
        width="260"
      >
        <div class="drawer-header">
          <v-img
            :src="require('../../../assets/nova/NOMBREBLANCO.png')"
            max-height="60"
            contain
            class="ma-4"
          ></v-img>
        </div>

        <v-divider class="mx-4 mb-4" dark style="opacity: 0.1"></v-divider>

        <div class="user-profile px-4 py-6">
          <v-avatar color="rgba(255,255,255,0.1)" size="64" class="mb-3">
            <v-icon dark size="40">mdi-account-circle</v-icon>
          </v-avatar>
          <div class="user-name">{{ nombre }}</div>
          <div class="user-role">{{ rol }}</div>
        </div>

        <v-list nav dense class="mt-4">
          <v-list-item-group color="white">
            <v-list-item to="/Premios/Usuario" exact active-class="active-item">
              <v-list-item-icon>
                <v-icon color="white">mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">Inicio</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <template v-slot:append>
          <div class="pa-4 drawer-footer d-flex align-center justify-center">
            <v-img
                :src="require('../../../assets/LOGO-FACILISIMO-GRIS.png')"
                contain
                max-height="30"
                max-width="120"
                class="mr-2"
                style="filter: brightness(0) invert(1); opacity: 0.5"
            ></v-img>

            <v-img
                :src="require('../../../assets/nova/LOGO APOSTAR-06.png')"
                contain
                max-height="30"
                max-width="120"
                style="filter: brightness(0) invert(1); opacity: 0.5"
            ></v-img>
          </div>
        </template>
      </v-navigation-drawer>

      <!-- Contenido Principal -->
      <v-main class="dashboard-main">
        <v-container fluid fill-height class="pa-6 content-container">
          <v-fade-transition mode="out-in">
            <router-view />
          </v-fade-transition>
        </v-container>
      </v-main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardUser',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#294697'
    },
    size: {
      type: String,
      default: '15px'
    }
  },
  data() {
    return {
      propLoading: true,
      nombre: localStorage.getItem("nombre"),
      rol: localStorage.getItem("rol"),
      drawer: true,
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: '2px',
        borderRadius: '100%',
        display: 'inline-block',
        animation: 'v-syncStretchDelay 0.6s infinite ease-in-out both'
      }
    }
  },
  methods: {
    logout() {
      this.$router.push("/");
    }
  },
  mounted() {
    setTimeout(() => {
      this.propLoading = false;
    }, 800);
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&family=Source+Sans+Pro:wght@400;600&display=swap');

.dashboard-container {
  font-family: 'Source Sans Pro', sans-serif;
  background-color: #f4f7f9;
  min-height: 100vh;
}

.loading-overlay {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}

.dashboard-layout {
  display: flex;
  flex-direction: column;
}

.dashboard-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.brand-title {
  font-family: 'Poppins', sans-serif;
  font-size: 1.2rem;
  letter-spacing: 1px;
}

.text-primary {
  color: #294697;
}

.text-secondary {
  color: #64748b;
}

.dashboard-drawer {
  background: linear-gradient(180deg, #1D3C7F 0%, #112552 100%) !important;
  border: none !important;
}

.drawer-header {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.user-name {
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  font-family: 'Poppins', sans-serif;
}

.user-role {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 4px;
}

.active-item {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px !important;
}

.dashboard-main {
  background-color: #f4f7f9;
  padding: 0 !important;
}

.logout-btn {
  font-weight: 600;
  letter-spacing: 1px;
}

@keyframes v-syncStretchDelay {
  33% { transform: translateY(10px); }
  66% { transform: translateY(-10px); }
  100% { transform: translateY(0); }
}

.v-sync1 { animation-delay: 0.07s !important; }
.v-sync2 { animation-delay: 0.14s !important; }
.v-sync3 { animation-delay: 0.21s !important; }
</style>
